import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const confirmAllocation = createAsyncThunk(
    "tms/confirmAllocation",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.post(`tms/tenders/allocate`, payload);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

export const markPaymentDone = createAsyncThunk(
    "tms/markPaymentDone",
    async (allocationId, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.put(`tms/allocations/${allocationId}/payment-done`);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

export const rejectBid = createAsyncThunk(
    "tms/rejectBid",
    async (bidId, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.patch(`tms/bids/${bidId}/reject`);
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

const AllocationManagementSlice = createSlice({
    name: "AllocationManagementSlice",
    initialState: {
        loading: false,
        success: false,
        error: null,
    },
    reducers: {
        resetAllocationManagement: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // confirmAllocation
        builder.addCase(confirmAllocation.pending, (state) => {
            state.loading = true;
            state.success = false;
        });
        builder.addCase(confirmAllocation.fulfilled, (state) => {
            state.loading = false;
            state.success = true;
        });
        builder.addCase(confirmAllocation.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // markPaymentDone
        builder.addCase(markPaymentDone.pending, (state) => {
            state.loading = true;
            state.success = false;
        });
        builder.addCase(markPaymentDone.fulfilled, (state) => {
            state.loading = false;
            state.success = true;
        });
        builder.addCase(markPaymentDone.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // rejectBid
        builder.addCase(rejectBid.pending, (state) => {
            state.loading = true;
            state.success = false;
        });
        builder.addCase(rejectBid.fulfilled, (state) => {
            state.loading = false;
            state.success = true;
        });
        builder.addCase(rejectBid.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { resetAllocationManagement } = AllocationManagementSlice.actions;
export default AllocationManagementSlice.reducer;
